@if (mode() === 'button') {
  <button
    mat-stroked-button
    type="button"
    [matMenuTriggerFor]="pool().length ? fieldMenu : null"
    (click)="onAddClick()"
  >
    <mat-icon>add</mat-icon>
    {{ 'button.addFilter' | translate }}
  </button>
} @else {
  @if (pickedField(); as field) {
    <app-filter-card-field-input
      [field]="field"
      (commit)="commit($event)"
      (pendingChange)="onPendingChange($event)"
      (dismissed)="dismiss(true)"
    ></app-filter-card-field-input>
  }
}

<mat-menu #fieldMenu="matMenu">
  @for (field of pool(); track field.name) {
    <button mat-menu-item (click)="pickField(field)">{{ field.label }}</button>
  }
</mat-menu>
